import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Alert, Spinner } from 'reactstrap';
import { Navigate } from 'react-router-dom';
import { withTranslator } from '../../../I18n/withTranslator';

// import withFirebase from 'view/FirebaseAnalytics/withFirebase';
import { Link } from 'react-router-dom';

import InputEmail from '../../../FormElements/InputEmailControlled';
import InputPassword from '../../../FormElements/InputPasswordControlled';

import { validateField } from '../../../Validation/validateField';
import { validateFields } from '../../../Validation/validateFields';
import RequiredRule from '../../../Validation/ValidationRules/RequiredRule';
import EmailFormatRule from '../../../Validation/ValidationRules/EmailFormatRule';
import ValidationErrors from '../../../Validation/ValidationErrors';
import setAuthCredentials from '../../setAuthCredentials';

class AuthLoginByEmailAndPasswordForm extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    login: PropTypes.func.isRequired,
    redirectToPathAfterSuccess: PropTypes.string.isRequired,
    userDataOnDemand: PropTypes.func.isRequired,
    // trackFirebaseEvent: PropTypes.func.isRequired,
    comesFromStripe: PropTypes.bool,
    loading: PropTypes.bool,
    icons: PropTypes.shape().isRequired,
  };

  static defaultProps = {
    comesFromStripe: false,
    loading: false,
  };

  state = {
    email: '',
    password: '',
    shouldRedirect: false,
    errors: new ValidationErrors(),
    success: false,
    loginError: false,
  };

  validationRules = {
    email: [
      new RequiredRule({ translator: this.props.t }),
      new EmailFormatRule({ translator: this.props.t }),
    ],
    password: [new RequiredRule({ translator: this.props.t })],
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    const frontEndErrors = validateFields(this.validationRules, this.state);

    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        details: frontEndErrors,
      },
    }));

    if (frontEndErrors.length === 0) {
      const request = {
        email: this.state.email,
        password: this.state.password,
      };

      try {
        const response = await this.props.login(request);
        const { __typename, token } = response.data.auth.login;

        if (__typename === 'AuthLoginSuccess') {
          setAuthCredentials(token);
          await this.props.userDataOnDemand();

          this.setState({
            email: '',
            password: '',
            errors: new ValidationErrors(),
            success: true,
            loginError: false,
            shouldRedirect: true,
          });
        } else {
          this.setState({
            success: false,
            loginError: true,
          });
        }
      } catch (e) {
        this.setState({ success: false, preload: false });
        throw new Error(`Failed to login, got error: ${e}`);
      }
    }
  };

  handleInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
    this.validateInput(event.target.name, event.target.value);
  };

  validateInput = (field, value) => {
    if (this.validationRules[field]) {
      this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          details: validateField(field, value, this.validationRules[field], prevState),
        },
      }));
    }
  };

  render() {
    if (this.state.shouldRedirect && this.props.redirectToPathAfterSuccess) {
      if (this.props.comesFromStripe) {
        this.props.trackFirebaseEvent('user_action', {
          action: 'tap-stripe_login',
          location: 'stripe_login ',
          used_account: 'mail',
        });
      }
      return <Navigate replace to={this.props.redirectToPathAfterSuccess} />;
    }

    return (
      <React.Fragment>
        {this.state.loginError ? (
          <Alert color="danger" data-test="login-error">
            {this.props.t('auth/login/error-message')}
          </Alert>
        ) : (
          ''
        )}
        <Form onSubmit={this.handleSubmit} data-test="login-form">
          <InputEmail
            label={this.props.t('email')}
            name="email"
            autoComplete="username"
            value={this.state.email}
            errors={this.state.errors}
            handleChange={this.handleInputChange}
            validationRules={this.validationRules.email}
            showAsterisk={false}
            data-test="email-input"
          />

          <InputPassword
            label={this.props.t('password')}
            name="password"
            autoComplete="current-password"
            value={this.state.password}
            errors={this.state.errors}
            handleChange={this.handleInputChange}
            validationRules={this.validationRules.password}
            showAsterisk={false}
            data-test="password-input"
            iconEye={this.props.icons.eye}
            iconEyeSlash={this.props.icons.eyeSlash}
          />
          <p className="text-center my-4">
            <Link to={'/auth/remind-password'} data-test="remind-password-link">
              {this.props.t('auth/remind-password/link-text')}
            </Link>
          </p>
          <div className="text-center">
            {this.props.loading ? (
              <Button color="primary" className="w-100" disabled>
                <Spinner size="sm">Loading...</Spinner> {this.props.t('auth/login/title')}
              </Button>
            ) : (
              <Button color="primary" className="w-100">
                {this.props.t('auth/login/login-btn-text')}
              </Button>
            )}
          </div>
        </Form>
      </React.Fragment>
    );
  }
}

export default withTranslator(AuthLoginByEmailAndPasswordForm);
